export const TIME_CHART_SIZE = {
  DEFAULT: "DEFAULT",
  LARGE: "LARGE",
};

export const TIME_CHART_VARIANTS = {
  COMPLETE: "complete",
  IN_PROGRESS: "in-progress",
  UPCOMING: "upcoming",
};

export const TIME_CHART_ICONS = {
  ARRIVAL: "ARRIVAL",
  DEPARTURE: "DEPARTURE",
};
